import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsSection';
import { AppState } from '../../../../types/store';
import { hasAnyDeviations } from '../../../selectors/folders';
import { isSectionLoading } from '../../../selectors/sections';
import {
  getSearchQuery,
  getViewType,
  getGallectionSectionType,
} from '../../../selectors/gallectionSection';

export type StateProps = Pick<
  Props,
  | 'hasAnyDeviations'
  | 'isSectionLoading'
  | 'searchQuery'
  | 'viewType'
  | 'gallectionType'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const gallectionSectionType = getGallectionSectionType(state);

  return {
    hasAnyDeviations: hasAnyDeviations(state),
    isSectionLoading: isSectionLoading(state),
    searchQuery: getSearchQuery(state),
    viewType: getViewType(state),
    gallectionType: gallectionSectionType,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
